<template>
  <div id="sponsor-add-new-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie   v-if="loading == 'updateScreenLoading' && form == null" key="create-loading"  />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.pic") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.picMsg") }}</span>
                    </div>
                    <i v-if="logoPercent > 0" class="el-icon-loading"></i>
                    <i class="el-icon-info" v-else></i>
                  </el-tooltip>
                </div>
                <div class="mage-maker" :style="{ background: `url(${form.image})` }">
                  <el-upload :onProgress="logoProgress" class="avatar-uploader" :style="{ opacity: form.image != null ? '0' : '1' }" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=areaMap&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" drag :show-file-list="false" :on-success="logoSuccess">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" v-html="$t('generic.uploadText')"></div>
                  </el-upload>
                </div>
                <span class="error">{{ $errorMessage("image", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.link") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.linkMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.externalLink" :placeholder="$t('exHol')"></el-input>
                <span class="error">{{ $errorMessage("externalLink", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" class="mt-2">
            <el-col :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableCustomTags ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.enableCustomTags ? 'fa-tags' : 'fa-tags'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.useTags") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.useTagsMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableCustomTags"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableCustomTags">
                        <CustomTag :value="form.customTags" :key="form.id" v-model="form.customTags"></CustomTag>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash" :loading="loading == 'deleteItem'">{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.delete") }} </el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.sponsors.sponsorAddUpdateAndCategoryAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
export default {
  components: { ItemInfo },
  name: "SponsorAddUpdate",
  props: ["id", "categoryId"],
  data() {
    return {
      settingsDock: false,
      form: null,
      logoPercent: 0,
      loading: false,
      timeout: null,
      axios,
      validationErrors: [],
      showInfo: false,
    };
  },
  methods: {
    deleteItem() {
      this.loading = "deleteItem";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.loading = false;
        this.$emit("deleteMe", this.form.id);
        this.$emit("closeDialog");
      }, 500);
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateSponsor", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          await this.$store.dispatch("getSponsors");
        }
        this.loading = false;
      }, 500);

      // this.validationErrors = [];
      // axios
      //   .post('sponsor/addorupdate', {
      //     ...this.form,
      //     categoryID: this.categoryId,
      //   })
      //   .then((res) => {
      //     this.validationErrors = res.data.validationErrors;
      //     if (res.data.alert.hasError) {
      //       this.$message.error(res.data.alert.message);
      //     } else {
      //       this.$message.success(res.data.alert.message);
      //       if (this.form.id == null) {
      //         this.$emit('itemAdded');
      //         this.form = {
      //           id: null,
      //           image: null,
      //           title: null,
      //           categoryID: null,
      //           orderNO: 99,
      //           externalLink: null,
      //           isActive: true,
      //           enableCustomTags: false,
      //           customTags: [],
      //         };
      //       } else {
      //         this.$emit('itemUpdated');
      //         if (this.showInfo) {
      //           this.showInfo = false;
      //           setTimeout(() => {
      //             this.showInfo = true;
      //           }, 350);
      //         }
      //       }
      //     }
      //   });
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    },
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);

    if (this.id != undefined && this.id != null) {
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getSponsor", this.id);
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit("closeDialog");
        }
        this.loading = false;
      }, 500);
    } else {
      this.timeout = setTimeout(() => {
        this.form = {
          id: null,
          image: null,
          title: null,
          categoryID: this.categoryId,
          orderNO: 99,
          externalLink: null,
          isActive: true,
          customTags: [],
          enableCustomTags: false,
        };
        this.loading = false;
      }, 500);
    }
  },
};
</script>

<style lang="less">
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.mage-maker {
  width: 100%;
  position: relative;
  border: 1px dashed #ccc;
  height: 250px;
  background-size: contain !important;
  background-position: center center !important;
  border-radius: 5px;
  background-repeat: no-repeat !important;
  .avatar-uploader {
    opacity: 0;
    transition: all 1s;
    &:hover {
      opacity: 1 !important;
    }
    & > .el-upload {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 250px !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SponsorAddUpdate.vue